module.exports = __webpack_public_path__ + "static/media/GB.6df46610.svg";